export const UserTokenRoles = {
  SelectedPos: 'SelectedPos',
  UnSelectedPos: 'UnSelectedPos',
  StaffValidation: 'StaffValidation',
  ExpiredPassword: 'ExpiredPassword',
  UnSelectedUser: 'UnSelectedUser',
  RegisterMFA: 'RegisterMfa',
  VerifyMFA: 'VerifyMfa',
};
